import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CheckRequestStatusEnum } from '@qaroni-app/check/types/check-request-status.enum';

@Component({
  selector: 'qaroni-check-requests-status-preview',
  templateUrl: './check-requests-status-preview.component.html',
  styleUrl: './check-requests-status-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckRequestsStatusPreviewComponent {
  readonly status = input<CheckRequestStatusEnum>(
    CheckRequestStatusEnum.PENDING
  );

  get chipClass(): string {
    switch (this.status()) {
      case CheckRequestStatusEnum.APPROVED:
        return 'border-secondary-90 bg-secondary-98 text-secondary-30';
      case CheckRequestStatusEnum.REJECTED:
        return 'border-warn-90 bg-warn-95 text-warn-40';
      case CheckRequestStatusEnum.PENDING:
      default:
        return 'border-accent-90 bg-accent-95 text-accent-40';
    }
  }
}
